import { render, staticRenderFns } from "./Schloss.vue?vue&type=template&id=e8ee6f8c&scoped=true&"
var script = {}
import style0 from "./Schloss.vue?vue&type=style&index=0&id=e8ee6f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ee6f8c",
  null
  
)

export default component.exports